import { Entity } from 'mk2/schemas';
import { schema } from 'normalizr';

export interface ArticleLinkEntity extends Entity {
    title: string;
    slug: string;
}

export const ArticleLinkSchema = new schema.Entity('articleLink', {});
